/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Feedback_PlaceholderInputs */

const en_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anything else you'd like to share?`)
};

const de_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moechtest du noch etwas teilen?`)
};

const fr_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autre chose a partager ?`)
};

const es_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Algo mas que quieras compartir?`)
};

const it_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altro da condividere?`)
};

const nl_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog iets dat je wilt delen?`)
};

const pl_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos jeszcze chcesz dodac?`)
};

const fi_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuta jaettavaa?`)
};

const da_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andet du vil dele?`)
};

const sv_cancel_feedback_placeholder = /** @type {(inputs: Cancel_Feedback_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Något annat du vill dela?`)
};

/**
* | output |
* | --- |
* | "Anything else you'd like to share?" |
*
* @param {Cancel_Feedback_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cancel_feedback_placeholder = /** @type {((inputs?: Cancel_Feedback_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Feedback_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cancel_feedback_placeholder(inputs)
	if (locale === "fr") return fr_cancel_feedback_placeholder(inputs)
	if (locale === "es") return es_cancel_feedback_placeholder(inputs)
	if (locale === "it") return it_cancel_feedback_placeholder(inputs)
	if (locale === "nl") return nl_cancel_feedback_placeholder(inputs)
	if (locale === "pl") return pl_cancel_feedback_placeholder(inputs)
	if (locale === "fi") return fi_cancel_feedback_placeholder(inputs)
	if (locale === "da") return da_cancel_feedback_placeholder(inputs)
	if (locale === "sv") return sv_cancel_feedback_placeholder(inputs)
	return en_cancel_feedback_placeholder(inputs)
});